import { render } from "./ShowPatient.vue?vue&type=template&id=2f4f62ac&scoped=true&ts=true"
import script from "./ShowPatient.vue?vue&type=script&lang=ts"
export * from "./ShowPatient.vue?vue&type=script&lang=ts"

import "./ShowPatient.vue?vue&type=style&index=0&id=2f4f62ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4f62ac"]])

export default __exports__